import React from 'react';

import { StyleSheet, View } from 'react-native';

import { Typography } from 'components/ui';
import { t } from 'state/intl/translations';
import { spacing } from 'styles/constants';

const Bullet = ({ label, value }: { label: string; value: string }) => (
  <View style={styles.bullet}>
    <Typography variant="bodyOne" bold>
      • {label} <Typography variant="bodyOne">{value}</Typography>
    </Typography>
  </View>
);

export const DeliveryTermsUS = () => {
  return (
    <>
      <Typography variant="headerThree" style={styles.title}>
        {t('deliveryTerms.title')}
      </Typography>
      <Typography variant="bodyOne" style={styles.body}>
        {t('deliveryTerms.intro')}
      </Typography>

      {/* All states */}
      <Typography variant="headerThree" style={styles.sectionHeading}>
        {t('deliveryTerms.statesHeading')}
      </Typography>
      <View style={styles.list}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.feeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
      </View>

      {/* Colorado */}
      <Typography variant="headerThree" style={styles.sectionHeadingWithTop}>
        {t('deliveryTerms.coloradoHeading')}
      </Typography>
      <View style={styles.list}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.feeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
        <Bullet
          label={t('deliveryTerms.retailFeeLabel')}
          value={t('deliveryTerms.retailFeeValue')}
        />
      </View>

      {/* California */}
      <Typography variant="headerThree" style={styles.sectionHeadingWithTop}>
        {t('deliveryTerms.californiaHeading')}
      </Typography>
      <View style={styles.list}>
        <Bullet label={t('deliveryTerms.feeLabel')} value={t('deliveryTerms.caFeeValue')} />
        <Bullet
          label={t('deliveryTerms.serviceFeeLabel')}
          value={t('deliveryTerms.serviceFeeValue')}
        />
        <Bullet
          label={t('deliveryTerms.smallCartLabel')}
          value={t('deliveryTerms.smallCartValue')}
        />
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  body: {
    marginBottom: spacing.$4,
  },
  bullet: {
    marginBottom: spacing.$2,
  },
  list: {
    paddingLeft: spacing.$4,
  },
  sectionHeading: {
    marginBottom: spacing.$2,
  },
  sectionHeadingWithTop: {
    marginBottom: spacing.$2,
    marginTop: spacing.$4,
  },
  title: {
    marginBottom: spacing.$4,
  },
});
